import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum FolderRiskStatusEnum {
    NO_RISK = 'noRisk',
    RISKY = 'risky',
    POSITIVE = 'positive',
}

export const folderRiskStatusEnumOptions = enumToOptions(FolderRiskStatusEnum, 'enum.folderRiskStatus.');
